import { render, staticRenderFns } from "./NwFormDietary.vue?vue&type=template&id=6a663320&scoped=true&"
import script from "./NwFormDietary.vue?vue&type=script&lang=js&"
export * from "./NwFormDietary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a663320",
  null
  
)

export default component.exports